export default __webpack_public_path__ + "static/media/massup_background_l1.017867b7.jpg";